webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_repository__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base2_repository__ = __webpack_require__(31);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__base_repository__["a" /* default */], {
    login: function login(username, password) {
        // const noCache = Math.round(Math.random()*10000000000);
        return this.post('auth/login', { username: username, password: password });
    },
    registerUser: function registerUser(payload) {
        return this.post('auth/register', payload);
    },
    recoverPassword: function recoverPassword(payload) {
        return this.post('users/recover-password', payload);
    },
    changePassword: function changePassword(payload) {
        // this.post('users/change-password-user', {userId: payload.userId, password1: payload.password1, password2: payload.password2, oldPassword: payload.oldPassword}); this.post('users/change-password-user', {userId: payload.userId, password1: payload.password1, password2: payload.password2, oldPassword: payload.oldPassword});
        return this.post('users/change-password-user', payload);
    },

    saveBrowserSpects: function saveBrowserSpects(userId, spects) {
        return __WEBPACK_IMPORTED_MODULE_2__base2_repository__["a" /* default */].post('users/' + userId + '/browser-spects', spects);
    },
    saveNotificationsSupport: function saveNotificationsSupport(userId, support) {
        return __WEBPACK_IMPORTED_MODULE_2__base2_repository__["a" /* default */].post('users/' + userId + '/notifications-support', support);
    },
    saveNotificationsAllowed: function saveNotificationsAllowed(userId, allowed) {
        return __WEBPACK_IMPORTED_MODULE_2__base2_repository__["a" /* default */].post('users/' + userId + '/notifications-allowed', allowed);
    },
    updateEmail: function updateEmail(userId, email) {
        return __WEBPACK_IMPORTED_MODULE_2__base2_repository__["a" /* default */].post('users/' + userId + '/update-email', { email: email });
    },
    confirmCode: function confirmCode(userId, code) {
        return __WEBPACK_IMPORTED_MODULE_2__base2_repository__["a" /* default */].post('users/' + userId + '/confirm-code', { code: code });
    }
}));

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INITIAL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_NOTIFICATIONS_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_NOTIFICATIONS_ALLOWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_BROWSER_SPECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VERIFY_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VALIDATE_VERSION; });
var LOAD_INITIAL_STATE = 'LOAD_INITIAL_STATE';
var LOGOUT = 'LOGOUT';
var SAVE_SUBSCRIPTION = 'SAVE_SUBSCRIPTION';
var SAVE_NOTIFICATIONS_SUPPORT = 'SAVE_NOTIFICATIONS_SUPPORT';
var SAVE_NOTIFICATIONS_ALLOWED = 'SAVE_NOTIFICATIONS_ALLOWED';
var SAVE_BROWSER_SPECTS = 'SAVE_BROWSER_SPECTS';
var UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
var VERIFY_SUBSCRIPTION = 'VERIFY_SUBSCRIPTION';
var VALIDATE_VERSION = 'VALIDATE_VERSION';

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_VISITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_MAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_HAS_SUBS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_UPDATED_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_REQUIRE_UPDATE; });
var SET_USER = 'SET_USER';
var SET_VISITS = 'SET_VISITS';
var SET_MAILS = 'SET_MAILS';
var SET_HAS_SUBS = 'SET_HAS_SUBS';
var SET_STATE = 'SET_STATE';
var SET_UPDATED_EMAIL = 'SET_UPDATED_EMAIL';
var SET_VERSION = 'SET_VERSION';
var SET_REQUIRE_UPDATE = 'SET_REQUIRE_UPDATE';

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(68);




var baseUrl = 'http://localhost:8000/api/';
/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].get(url);
    },
    newpost: function newpost(url) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            fetch('' + baseUrl + url, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, cors, *same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                    // "Content-Type": "application/x-www-form-urlencoded",
                },
                redirect: "follow", // manual, *follow, error
                referrer: "no-referrer", // no-referrer, *client
                body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload) // body data type must match "Content-Type" header
            }).then(function (resp) {
                return resolve(resp.json());
            }).catch(reject);
        });
    },
    post: function post(url) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var formData = new FormData();
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).map(function (key) {
            return formData.append(key, payload[key]);
        });
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].post(url, formData).then(function (resp) {
                resolve(resp);
            }).catch(function (error) {
                reject(error);
            });
        });
        // return axios.post(url, payload);
    },
    delete: function _delete(url) {
        return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].delete(url);
    },
    put: function put(url, payload) {
        return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].put(url, payload);
    },
    querify: function querify(params) {
        if (!params || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).length) return '';

        var arrParams = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
            return typeof params[key] !== 'undefined' && arrParams.push(key + '=' + params[key]);
        });
        var join = !!arrParams.length ? '?' : '';
        var queryString = join + arrParams.join('&');
        return queryString;
    }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(68);


/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url, payload) {
        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get('' + url + querify(payload));
    },
    post: function post(url, payload) {
        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].post(url, payload);
    }
});

var querify = function querify(params) {
    if (!params || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).length) return '';

    var arrParams = [];
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
        return typeof params[key] !== 'undefined' && arrParams.push(key + '=' + params[key]);
    });
    var join = !!arrParams.length ? '?' : '';
    var queryString = join + arrParams.join('&');
    return queryString;
};

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(302);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        user: null,
        visits: [],
        mails: [],
        hasSubscriptions: false,
        updatedEmail: '',
        version: '',
        updateRequired: false
    },
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */]
}));

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UI_Toolbar_Toolbar__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UI_NavDrawer_NavDrawer__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actionTypes_js__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        appToolbar: __WEBPACK_IMPORTED_MODULE_2__components_UI_Toolbar_Toolbar__["a" /* default */],
        appNavDrawer: __WEBPACK_IMPORTED_MODULE_3__components_UI_NavDrawer_NavDrawer__["a" /* default */]
    },
    name: 'App',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['authenticated', 'hasSubscriptions'])),
    created: function created() {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actionTypes_js__["a" /* LOAD_INITIAL_STATE */]);
    }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            searching: false,
            search: ''
        };
    },

    methods: {
        onSearchPress: function onSearchPress() {
            if (!this.searching) {
                this.searching = !this.searching;
            } else {
                if (!this.search.length) {
                    this.searching = !this.searching;
                } else {
                    this.startSearching();
                }
            }
        },
        startSearching: function startSearching() {
            var searchingIn = this.$route.path.substring(1);
            alert('Searching...' + searchingIn);
        }
    },
    created: function created() {}
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actionTypes__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_commitTypes__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            open: false,
            items: [{
                title: 'Mi Cuenta',
                icon: 'account_box',
                action: 'my-account'
            }, {
                title: 'Cerrar Sesión',
                icon: 'exit_to_app',
                action: 'logout'
            }],
            items2: [{
                title: 'Inicio',
                icon: 'home',
                action: 'home'
            }, {
                title: 'Visitas',
                icon: 'people',
                action: 'visits'
            }, {
                title: 'Correspondencia',
                icon: 'mail',
                action: 'mail'
            }, {
                title: 'Circulares',
                icon: 'announcement',
                action: 'broadcastMessages'
            }, {
                title: 'Conoce a Shatter',
                icon: 'favorite',
                action: 'meet-shatter'
            }]
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['hasSubscriptions']), {
        notificationSupported: function notificationSupported() {
            return 'Notification' in window;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
        subscribe: __WEBPACK_IMPORTED_MODULE_1__store_actionTypes__["g" /* UPDATE_SUBSCRIPTION */]
    }), {
        setEvents: function setEvents() {
            var _this = this;

            this.$bus.$on('nav-drawer.toggle', function () {
                return _this.open = !_this.open;
            });
        },
        initialize: function initialize() {
            this.setEvents();
        },
        onClick: function onClick(action) {
            var _this2 = this;

            switch (action) {
                case 'home':
                    this.$router.push({ name: 'home' });
                    break;
                case 'my-account':
                    this.$router.push({ name: 'MyAccount' });
                    break;
                case 'visits':
                    this.$router.push({ name: 'visits' });
                    break;
                case 'mail':
                    this.$router.push({ name: 'mail' });
                    break;
                case 'broadcastMessages':
                    this.$router.push({ name: 'broadcastMessages' });
                    break;
                case 'meet-shatter':
                    this.$router.push({ name: 'shatter' });
                    break;
                case 'logout':
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_actionTypes__["b" /* LOGOUT */]).then(function (resp) {
                        _this2.$router.push({ name: 'login' });
                    });
                    break;
            }
        },
        showNotification: function showNotification() {
            if ('serviceWorker' in navigator) {
                var options = {
                    body: 'Este es el cuerpo de la notificación'
                };
                navigator.serviceWorker.ready.then(function (swreg) {
                    swreg.showNotification('Notificación desde el SW', options);
                });
            }
        },
        requestNotificationPermission: function requestNotificationPermission() {
            var _this3 = this;

            Notification.requestPermission().then(function (result) {
                if (result !== 'granted') {
                    toastr.error('Notificaciones bloqueadas por el usuario');
                } else {
                    _this3.subscribe();
                }
            });
        }
    }),
    created: function created() {
        this.initialize();
    }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login_Login__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_Home__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Home: __WEBPACK_IMPORTED_MODULE_1__Home_Home__["a" /* default */],
        Login: __WEBPACK_IMPORTED_MODULE_0__Login_Login__["a" /* default */]
    },
    computed: {
        theComponent: function theComponent() {
            return this.$store.getters.authenticated ? __WEBPACK_IMPORTED_MODULE_1__Home_Home__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__Login_Login__["a" /* default */];
        }
    }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510105e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(295);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510105e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_auth_repository__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_commitTypes__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actionTypes__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bowser__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bowser__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			credentials: {
				username: '',
				password: ''
			},
			showPassword: false,
			loginError: false,
			errorMessage: 'Error desconocido',
			showNotificationsWindow: false,
			debug: ''
		};
	},

	watch: {
		'credentials.username': function credentialsUsername(val) {
			this.credentials.username = val.toLowerCase();
		}
	},
	computed: {
		browserSpects: function browserSpects() {
			return __WEBPACK_IMPORTED_MODULE_5_bowser___default.a.parse(window.navigator.userAgent);
		}
	},
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
		saveBrowserSpects: __WEBPACK_IMPORTED_MODULE_3__store_actionTypes__["c" /* SAVE_BROWSER_SPECTS */],
		saveNotificationsSupport: __WEBPACK_IMPORTED_MODULE_3__store_actionTypes__["e" /* SAVE_NOTIFICATIONS_SUPPORT */],
		updateSubscription: __WEBPACK_IMPORTED_MODULE_3__store_actionTypes__["g" /* UPDATE_SUBSCRIPTION */],
		saveNotificationsAllowed: __WEBPACK_IMPORTED_MODULE_3__store_actionTypes__["d" /* SAVE_NOTIFICATIONS_ALLOWED */]
	}), {
		login: function login() {
			var _this = this;

			var ar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__repositories_auth_repository__["a" /* default */]);
			ar.login(this.credentials.username.toLowerCase(), this.credentials.password).then(function (_ref) {
				var data = _ref.data;

				if (!data.status) {
					_this.errorMessage = data.msg;
					_this.loginError = true;
					return;
				}
				// this.$store.commit(commitTypes.SET_USER, resp.data);
				_this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_commitTypes__["f" /* SET_USER */], data.user);
				// this.$store.dispatch(actionTypes.VERIFY_SUBSCRIPTION);
				try {
					// if (browsertDetect() === 'safari')
					// 	this.finishNotificationSubscription()
					_this.startNotificationSubscription();
				} catch (error) {
					console.log(error);
				}
			}).catch(function (error) {
				if (error) {
					_this.loginError = true;
				}
			});
		},
		startNotificationSubscription: function startNotificationSubscription() {
			if (!window.hasOwnProperty('Notification')) {
				this.saveNotificationsSupport('NO');
				// this.errorMessage = 'Su navegador no soporta notificaciones'
				// this.loginError = true
				return this.finishNotificationSubscription();
			}
			this.saveNotificationsSupport('SI');
			if (Notification.permission === 'granted') {
				this.updateSubscription();
				this.finishNotificationSubscription();
			} else if (Notification.permission !== 'denied' || Notification.permission === 'default') {
				this.showNotificationsWindow = true;
			} else {
				this.errorMessage = 'Si desea recibir notificaciones debe habilitarlas manualmente';
				this.loginError = true;
				this.finishNotificationSubscription();
			}
		},
		acceptNotifications: function acceptNotifications() {
			var _this2 = this;

			Notification.requestPermission(function (permission) {
				if (permission === 'granted') {
					_this2.saveNotificationsAllowed('SI');
					_this2.updateSubscription().then(function (resp) {
						new Notification('Notificaciones activadas');
						_this2.finishNotificationSubscription();
					}).catch(function (error) {
						_this2.errorMessage = 'Ocurrió un error al subscribirse al servicio de notificaciones';
						_this2.loginError = true;
						_this2.finishNotificationSubscription();
					});
				} else {
					_this2.errorMessage = 'Notificaciones bloqueadas por el usuario';
					_this2.loginError = true;
					_this2.saveNotificationsAllowed('NO');
					_this2.finishNotificationSubscription();
				}
				_this2.showNotificationsWindow = false;
			});
		},
		denyNotifications: function denyNotifications() {
			this.showNotificationsWindow = false;
			this.saveNotificationsAllowed('NO');
			this.errorMessage = 'No recibirá notificaciones desde bitacorapp';
			this.loginError = true;
			this.finishNotificationSubscription();
		},
		finishNotificationSubscription: function finishNotificationSubscription() {
			this.$router.push({ name: 'home' });
		}
	}),
	created: function created() {}
});

var browsertDetect = function browsertDetect() {
	if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) != -1) {
		return 'opera';
	} else if (navigator.userAgent.indexOf('Chrome') != -1) {
		return 'chrome';
	} else if (navigator.userAgent.indexOf('Safari') != -1) {
		return 'safari';
	} else if (navigator.userAgent.indexOf('Firefox') != -1) {
		return 'firefox';
	} else if (navigator.userAgent.indexOf('MSIE') != -1 || !!document.documentMode == true) {
		//IF IE > 10
		return 'ie';
	} else {
		return 'unknown';
	}
};

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var baseUrl = window.location.origin.includes('localhost') ? 'http://localhost:8000/api/' : 'https://bitacorapp.com/api/';

var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: baseUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e6998d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(309);
function injectStyle (ssrContext) {
  __webpack_require__(296)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e6998d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e6998d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu_Menu__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actionTypes__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'home',
    components: {
        appMenu: __WEBPACK_IMPORTED_MODULE_1__Menu_Menu__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['updateRequired']), {
        anUpdateRequired: function anUpdateRequired() {
            return !!__WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('bitacorapp_update_required');
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
        validateVersion: 'VALIDATE_VERSION'
    }), {
        updateApp: function updateApp() {
            // this.$store.commit('SET_REQUIRE_UPDATE', false);
            __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.remove('bitacorapp_update_required');
            setTimeout(function () {
                return location.reload(true);
            }, 500);
            // location.reload(true);
        }
    })
    // async beforeRouteEnter(to, from, next) {

    //     const version = await store.dispatch('VALIDATE_VERSION');

    //     debugger;
    //     const currentVersion = Cookies.get('bitacorapp_app_version');
    //     if(!currentVersion) {
    //         Cookies.set('bitacorapp_app_version', version, { expires: 365 });
    //         store.commit('SET_REQUIRE_UPDATE', true);
    //     } else {

    //         if(currentVersion !== version) {
    //             store.commit('SET_REQUIRE_UPDATE', true);
    //             Cookies.set('bitacorapp_app_version', version, { expires: 365 });
    //         } else {
    //             store.commit('SET_REQUIRE_UPDATE', false);
    //         }
    //     }

    //     next();
    // }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_604df370_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(297);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_604df370_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commitTypes__ = __webpack_require__(21);




var _commitTypes$SET_USER;



var persistState = function persistState(state) {
    // const theState = {...state};
    // const blackList = ['updateRequired'];
    // blackList.map(key => (delete theState[key]));
    localStorage.setItem('bm_state', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state));
};

/* harmony default export */ __webpack_exports__["a"] = (_commitTypes$SET_USER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["f" /* SET_USER */], function (state, user) {
    state.user = user;
    persistState(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["h" /* SET_VISITS */], function (state, visits) {
    state.visits = visits;
    persistState(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["b" /* SET_MAILS */], function (state, mails) {
    state.mails = mails;
    persistState(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["a" /* SET_HAS_SUBS */], function (state, hasSubs) {
    state.hasSubscriptions = !!hasSubs;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["d" /* SET_STATE */], function (state, initialState) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(initialState).forEach(function (key) {
        return state[key] = initialState[key];
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["e" /* SET_UPDATED_EMAIL */], function (state, updatedEmail) {
    state.updatedEmail = updatedEmail;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["g" /* SET_VERSION */], function (state, version) {
    state.version = version;
    persistState(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_commitTypes$SET_USER, __WEBPACK_IMPORTED_MODULE_3__commitTypes__["c" /* SET_REQUIRE_UPDATE */], function (state, updateRequired) {
    state.updateRequired = updateRequired;
    persistState(state);
}), _commitTypes$SET_USER);

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_visits_repository__ = __webpack_require__(312);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            page: 1,
            data: null,
            filters: {},
            visitorsTypes: [],
            menu: ''
        };
    },

    watch: {
        page: function page(val) {
            this.loadVisits();
        }
    },
    computed: {
        visits: function visits() {
            if (!this.data) return [];
            return this.data.data;
        },
        totalPages: function totalPages() {
            if (!this.data) return 0;

            return Math.ceil(this.data.total / parseInt(this.data.per_page));
        }
    },
    methods: {
        loadVisits: function loadVisits() {
            var _this = this;

            var vr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__repositories_visits_repository__["a" /* default */]);
            vr.getPersonVisits(this.person.id, this.filters, this.page).then(function (resp) {
                _this.data = resp.data;
            }).catch(function (error) {
                if (error) {
                    console.log(error);
                }
            });
        },
        searchVisits: function searchVisits() {
            this.page = 1;
            this.loadVisits();
        },
        cancelFilter: function cancelFilter() {
            var _this2 = this;

            this.page = 1;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).map(function (key) {
                return _this2.filters[key] = '';
            });
            this.loadVisits();
        },
        loadVisitorTypes: function loadVisitorTypes() {
            var _this3 = this;

            var vr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__repositories_visits_repository__["a" /* default */]);
            vr.getVisitorTypes().then(function (resp) {
                _this3.visitorsTypes = resp.data;
            }).catch(function (error) {
                // toastr.error('Error al cargar los tipos de visitantes', {dismissible: false});
                console.log(error);
            });
        },
        initialize: function initialize() {
            this.loadVisits();
            this.loadVisitorTypes();
        }
    },
    created: function created() {
        this.initialize();
    }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},
	computed: {},
	methods: {
		sendResponse: function sendResponse(val) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _ref, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://bitacorapp.com/access-control/authorization/response-app?authorizationId=" + _this.$route.query.aid + "&responseById=" + _this.user.id + "&response=" + val);

							case 2:
								_ref = _context.sent;
								data = _ref.data;

								if (data.status) {
									toastr.success("Respuesta notificada");
									_this.$router.push({ name: "home" });
								} else {
									toastr.error(data.msg);
								}

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	}
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_mail_repository__ = __webpack_require__(318);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			data: {},
			page: 1,
			filters: {},
			mailTypes: [],
			menu: '',
			dialog: false,
			notifications: false,
			sound: true,
			widgets: false,
			selectMail: ''
		};
	},

	watch: {
		page: function page(val) {
			this.loadMails();
		}
	},
	computed: {
		mails: function mails() {
			if (!this.data) return [];

			return this.data.data;
		},
		totalPages: function totalPages() {
			if (!this.data) return 0;

			return Math.ceil(this.data.total / parseInt(this.data.per_page));
		}
	},
	methods: {
		loadMails: function loadMails() {
			var _this = this;

			var mr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__repositories_mail_repository__["a" /* default */]);
			mr.getMails(this.person.id, this.filters, this.page).then(function (resp) {
				return _this.data = resp.data;
			}).catch(function (error) {
				return alert('Ocurrió un error al cargar la correspondencia');
			});
		},
		searchMails: function searchMails() {
			this.page = 1;
			this.loadMails();
		},
		cancelFilter: function cancelFilter() {
			var _this2 = this;

			this.page = 1;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).map(function (key) {
				return _this2.filters[key] = '';
			});
			this.loadMails();
		},
		loadMailTypes: function loadMailTypes() {
			var _this3 = this;

			var mr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__repositories_mail_repository__["a" /* default */]);
			mr.getMailTypes().then(function (resp) {
				_this3.mailTypes = resp.data;
			}).catch(function (error) {
				// toastr.error('Error al cargar los tipos de correspondencia', {dismissible: false});
				console.log(error);
			});
		},
		seeMore: function seeMore(mail) {
			this.dialog = true;
			this.selectMail = mail;
		},
		closeDialogSeeMore: function closeDialogSeeMore() {
			this.dialog = false;
			this.selectMail = '';
		},
		initialize: function initialize() {
			this.loadMails();
			this.loadMailTypes();
		}
	},
	created: function created() {
		this.initialize();
	}
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shatterinfo_json__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shatterinfo_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shatterinfo_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'About',
    data: function data() {
        return {
            shatterInfo: null
        };
    },

    methods: {
        loadShatterInfo: function loadShatterInfo() {
            // $.getJSON('shatterinfo.json', function(data) {
            //     this.shatterInfo = data;
            // });
            this.shatterInfo = __WEBPACK_IMPORTED_MODULE_0__shatterinfo_json___default.a;
        }
    },
    created: function created() {
        this.loadShatterInfo();
    }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_auth_repository__ = __webpack_require__(11);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            register: {
                clientCode: '',
                name: '',
                document: '',
                email: '',
                birthDate: '',
                structure: '',
                optIn: []
            },
            structures: [],
            birthDateMenu: false
        };
    },

    validations: {
        register: {
            clientCode: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], minLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(4), maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(4) },
            name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
            document: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
            email: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"] },
            birthDate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
            structure: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
        }
    },
    computed: {
        formatedDate: function formatedDate() {
            if (!this.register.birthDate) return '';
            return moment(this.register.birthDate).format('D/M/Y');
        },
        errors: function errors() {
            return {
                clientCode: this.$v.register.clientCode.$error ? ['Debe escribir el código de 4 dígitos proporcionado por la administración'] : [],
                name: this.$v.register.name.$error ? ['Debe escribir nombre completo'] : [],
                document: this.$v.register.document.$error ? ['Debe escribir documento de identificación'] : [],
                email: this.$v.register.email.$error ? ['Debe escribir el E-mail'] : [],
                birthDate: this.$v.register.birthDate.$error ? ['Debe seleccionar la fecha de nacimiento'] : [],
                structure: this.$v.register.structure.$error ? ['Debe seleccionar la estructura'] : []
            };
        }
    },
    methods: {
        loadStructures: function loadStructures() {},
        registerUser: function registerUser() {
            var _this = this;

            this.$v.$touch();

            if (this.$v.$invalid) return;

            this.startProcessing();

            var ar = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__repositories_auth_repository__["a" /* default */]);
            ar.registerUser(this.register).then(function (resp) {
                _this.stopProcessing();
                var status = resp.data;

                if (!!status.status) {
                    toastr.success('Registro exitoso, la administración le notificará cuando su usuario sea activado', {
                        timeout: 6000
                    });
                    _this.clearForm();
                    _this.$router.push({ name: 'login' });
                } else {
                    toastr.error(status.msg);
                }
            }).catch(function (error) {
                _this.stopProcessing();
                toastr.error('Error en el registro');
            });
        },
        clearForm: function clearForm() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.register).map(function (key) {
                return _this2.register[key] = '';
            });
        }
    }
});

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_auth_repository_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            email: ''
        };
    },

    validations: {
        email: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"] }
    },
    computed: {
        errors: function errors() {
            return {
                email: this.$v.email.$error ? ['Debe escribir un E-mail valido'] : []
            };
        }
    },
    methods: {
        resetPassword: function resetPassword() {
            var _this = this;

            this.$v.$touch();

            if (this.$v.$invalid) return;

            this.startProcessing();

            var payload = { email: this.email };

            var ar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__repositories_auth_repository_js__["a" /* default */]);
            ar.recoverPassword(payload).then(function (resp) {
                _this.stopProcessing();
                var status = resp.data;

                if (!!status.status) {
                    toastr.success(status.msg, {
                        timeout: 6000
                    });
                    _this.email = '';
                    _this.$router.push({ name: 'login' });
                } else {
                    toastr.error(status.msg);
                }
            }).catch(function (error) {
                _this.stopProcessing();
                toastr.error('Error al enviar petición');
            });
        }
    }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loginGuard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_commitTypes__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);



var _this = this;





var getState = function getState() {
    var jsonState = localStorage.getItem('bm_state');
    return !!jsonState ? JSON.parse(jsonState) : null;
};

var loginGuard = function loginGuard(to, from, next) {
    var state = getState();
    var user = !!state && !!state.user ? state.user : null;

    if (!!user) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_3__store_commitTypes__["f" /* SET_USER */], user);
    }

    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.authenticated) return next();
    next({ name: 'login' });
};

var updateGuard = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
        var version, currentVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(to.name !== 'home')) {
                            _context.next = 2;
                            break;
                        }

                        return _context.abrupt('return', next());

                    case 2:
                        _context.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('VALIDATE_VERSION');

                    case 4:
                        version = _context.sent;
                        currentVersion = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('bitacorapp_app_version');

                        if (!currentVersion) {
                            __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('bitacorapp_app_version', version, { expires: 365 });
                            __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('bitacorapp_update_required', 1, { expires: 365 });
                            // store.commit('SET_REQUIRE_UPDATE', true);
                        } else {

                            if (currentVersion !== version) {
                                // store.commit('SET_REQUIRE_UPDATE', true);
                                __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('bitacorapp_app_version', version, { expires: 365 });
                                __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('bitacorapp_update_required', 1, { expires: 365 });
                            } else {
                                // store.commit('SET_REQUIRE_UPDATE', false);
                                __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove('bitacorapp_update_required');
                            }
                        }

                        next();

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function updateGuard(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangePassword_ChangePassword_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChangeEmail_ChangeEmail_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_auth_repository__ = __webpack_require__(11);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        appChangePassword: __WEBPACK_IMPORTED_MODULE_3__ChangePassword_ChangePassword_vue__["a" /* default */],
        appChangeEmail: __WEBPACK_IMPORTED_MODULE_4__ChangeEmail_ChangeEmail_vue__["a" /* default */]
    },
    data: function data() {
        return {
            active: null
        };
    },

    methods: {
        onChangeEmail: function onChangeEmail(email) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var ar, _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                ar = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__repositories_auth_repository__["a" /* default */]);
                                _context.prev = 1;
                                _context.next = 4;
                                return ar.updateEmail(_this.user.id, email);

                            case 4:
                                _ref = _context.sent;
                                data = _ref.data;

                                if (data.status) {
                                    _this.$router.push({ name: 'udateEmailConfirm' });
                                } else {
                                    toastr.error(data.msg);
                                }
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](1);

                                toastr.error('Ocurrió un error al intentar actualizar el correo');

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 9]]);
            }))();
        }
    },
    created: function created() {
        if (!this.user) this.$router.push({ name: 'login' });
    }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_auth_repository_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showOldPassword: false,
            showNewPassword1: false,
            showNewPassword2: false,
            passwords: {
                oldPassword: '',
                newPassword1: '',
                newPassword2: ''
            },
            changePasswordMsg: false,
            msg: ''
        };
    },

    validations: {
        passwords: {
            oldPassword: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
            newPassword1: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
            newPassword2: { sameAs: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])('newPassword1') }
        }
    },
    computed: {
        errors: function errors() {
            return {
                oldPassword: this.$v.passwords.oldPassword.$error ? ['Debe escribir la contraseña actual'] : [],
                newPassword1: this.$v.passwords.newPassword1.$error ? ['Debe escribir la nueva contraseña'] : [],
                newPassword2: this.$v.passwords.newPassword2.$error ? ['La contraseña debe coincidir'] : []
            };
        }
    },
    methods: {
        changePassword: function changePassword() {
            var _this = this;

            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Debe diligenciar correctamente todos los campos obligatorios');
                return false;
            }
            this.startProcessing();

            var payload = {
                userId: this.user.id,
                password1: this.passwords.newPassword1,
                password2: this.passwords.newPassword2,
                oldPassword: this.passwords.oldPassword
            };

            var ar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__repositories_auth_repository_js__["a" /* default */]);
            ar.changePassword(payload).then(function (resp) {
                _this.stopProcessing();
                var status = resp.data;
                _this.msg = status.msg;
                if (status.status) {
                    _this.cleanFields();
                    _this.$v.$reset();
                    _this.$router.push({ name: 'login' });
                }
                _this.changePasswordMsg = true;
            }).catch(function (error) {
                _this.stopProcessing();
                _this.msg = "Error al cambiar la contraseña";
                _this.changePasswordMsg = true;
            });
        },
        cleanFields: function cleanFields() {
            this.oldPassword = '';
            this.newPassword1 = '';
            this.newPassword2 = '';
        }
    }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            email: ''
        };
    },
    validations: {
        email: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"] }
    },
    computed: {
        emailErrors: function emailErrors() {
            var errors = [];
            !this.$v.email.required && errors.push('El campo es requerido');
            !this.$v.email.email && errors.push('Debe ser un correo electrónico válido');
            return errors;
        }
    },
    methods: {
        confirm: function confirm() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.$emit('confirm', this.email);
        }
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_broadcastMessages_repository__ = __webpack_require__(360);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'broadcast_messages',
    data: function data() {
        return {
            filters: {
                date: ''
            },
            page: 1,
            data: null,
            dialog: false,
            selectedMessage: null
        };
    },
    watch: {
        page: function page(val) {
            this.searchBroadcastMessages();
        }
    },
    computed: {
        totalPages: function totalPages() {
            if (!this.data) return 0;

            return Math.ceil(this.data.total / parseInt(this.data.per_page));
        },
        messages: function messages() {
            if (!this.data) return [];

            return this.data.data;
        }
    },
    methods: {
        searchBroadcastMessages: function searchBroadcastMessages() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var bmr, _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                bmr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__repositories_broadcastMessages_repository__["a" /* default */]);
                                _context.prev = 1;
                                _context.next = 4;
                                return bmr.getBroadcastMessages(_this.user.id, _this.filters, _this.page);

                            case 4:
                                _ref = _context.sent;
                                data = _ref.data;

                                _this.data = data;
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](1);

                                toastr.error('Ocurri\xF3 un error al cargar las circulares [' + _context.t0.message + ']');

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 9]]);
            }))();
        },
        drillDown: function drillDown(message) {
            this.selectedMessage = message;
            this.dialog = true;
        },
        drillUp: function drillUp() {
            this.selectedMessage = null;
            this.dialog = false;
        }
    },
    created: function created() {
        this.searchBroadcastMessages();
    }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_services_repository__ = __webpack_require__(365);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'request_assistance',
    methods: {
        requestAssistance: function requestAssistance() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var sr, _ref, _ref$data, status, msg;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                sr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__repositories_services_repository__["a" /* default */]);
                                _context.prev = 1;
                                _context.next = 4;
                                return sr.requestAssistance(_this.user.id);

                            case 4:
                                _ref = _context.sent;
                                _ref$data = _ref.data;
                                status = _ref$data.status;
                                msg = _ref$data.msg;


                                if (status) {
                                    toastr.success(msg);
                                } else {
                                    toastr.error(msg);
                                }
                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](1);

                                toastr.error('La asistencia no esta disponible en este momento');

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 11]]);
            }))();
        }
    }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_auth_repository__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            code: ''
        };
    },
    validations: {
        code: {
            required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
            numeric: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["numeric"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["minLength"])(4),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(4)
        }
    },
    computed: {
        codeErrors: function codeErrors() {
            var errors = [];

            !this.$v.code.required && errors.push('El código es requerido');
            !this.$v.code.numeric && errors.push('El código es numérico');
            !this.$v.code.minLength && errors.push('El código es de mínimo 4 digitos');
            !this.$v.code.maxLength && errors.push('El código es de máximo 4 digitos');

            return errors;
        }
    },
    methods: {
        validateCode: function validateCode() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var ar, _ref, data, user;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$v.$touch();

                                if (!_this.$v.$invalid) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:
                                ar = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__repositories_auth_repository__["a" /* default */]);
                                _context.next = 6;
                                return ar.confirmCode(_this.user.id, _this.code);

                            case 6:
                                _ref = _context.sent;
                                data = _ref.data;


                                if (data.status) {
                                    user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.user, { email: data.updateRequest.email });


                                    _this.$store.commit('SET_USER', user);

                                    toastr.success('Información actualizada');
                                    _this.$router.push({ name: 'home' });
                                } else {
                                    toastr.error(data.msg);
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_style_scss__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scss_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UI_Layout_PageContent__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UI_Layout_Title__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixin__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_cookies__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__register_sw__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__register_sw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__register_sw__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a, { theme: __WEBPACK_IMPORTED_MODULE_8__theme__["a" /* theme */] });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue_cookies___default.a.config('180d');
// Vue.use(Vuetify)

// General Mixins
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_12__mixin__["a" /* mixin */]);

window.moment = __webpack_require__(0);
window.toastr = __webpack_require__(386);
window.$ = window.jQuery = __webpack_require__(387);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

// general components
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('app-page-content', __WEBPACK_IMPORTED_MODULE_10__components_UI_Layout_PageContent__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('app-title', __WEBPACK_IMPORTED_MODULE_11__components_UI_Layout_Title__["a" /* default */]);

// Filtros de vue
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('datetime', __WEBPACK_IMPORTED_MODULE_9__filters__["a" /* datetime */]);

var EventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
// Asignar bus de eventos globales
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, {
    $bus: {
        get: function get() {
            return EventBus;
        }
    }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
    template: '<App/>'
});

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f40009ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(242);
function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f40009ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3de303e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__(239);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3de303e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"color":"primary","dark":"","app":"","fixed":"","scroll-off-screen":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){_vm.$bus.$emit('nav-drawer.toggle')}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.searching)?_c('v-text-field',{attrs:{"placeholder":"buscar","autofocus":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.onSearchPress}},[_c('v-icon',[_vm._v("search")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavDrawer_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b678a726_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavDrawer_vue__ = __webpack_require__(241);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavDrawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b678a726_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavDrawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"dark":"","absolute":"","fixed":"","value":_vm.open}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"title"},[_vm._v("\n            Menu\n        ")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.onClick(item.action)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)})),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.items2),function(item){return _c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.onClick(item.action)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)})),_vm._v(" "),(_vm.notificationSupported)?_c('v-btn',{attrs:{"variant":"danger"},on:{"click":_vm.requestNotificationPermission}},[_vm._v(_vm._s(_vm.hasSubscriptions?'Actualizar Subscripción':'Subscribirse a las notificaciones'))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{attrs:{"fluid":""}},[(_vm.authenticated)?_c('v-layout',[_c('app-toolbar',{staticClass:"toolbar"})],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"content"},[_c('router-view')],1),_vm._v(" "),(_vm.$route.path !== '/')?_c('v-btn',{attrs:{"color":"#90A4AE","dark":"","small":"","bottom":"","right":"","fab":"","fixed":""},on:{"click":function($event){_vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("chevron_left")])],1):_vm._e()],1),_vm._v(" "),_c('app-nav-drawer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guards__ = __webpack_require__(88);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    // mode: 'history',
    routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* routes */]
});



router.beforeEach(__WEBPACK_IMPORTED_MODULE_3__guards__["b" /* updateGuard */]);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 244 */,
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Main_Main__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Home_Menu_Menu__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login_Login__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home_Home__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Visits_Visits__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Visits_ViewVisitor__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Mail_Mail__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Shatter_Shatter__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Login_Register_Register__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Login_RecoverPassword_RecoverPassword__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__guards__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_MyAccount_MyAccount_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_BroadcastMessages_BroadcastMessages__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assistance_RequestAssistance__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_MyAccount_ChangeEmail_UpdateEmailConfirm__ = __webpack_require__(367);
















var routes = [{
	path: '/',
	component: __WEBPACK_IMPORTED_MODULE_3__pages_Home_Home__["a" /* default */],
	exact: true,
	name: 'home',
	beforeEnter: __WEBPACK_IMPORTED_MODULE_10__guards__["a" /* loginGuard */]
}, {
	path: '/login',
	component: __WEBPACK_IMPORTED_MODULE_2__pages_Login_Login__["a" /* default */],
	name: 'login'
}, {
	path: '/visits',
	component: __WEBPACK_IMPORTED_MODULE_4__pages_Visits_Visits__["a" /* default */],
	name: 'visits',
	beforeEnter: __WEBPACK_IMPORTED_MODULE_10__guards__["a" /* loginGuard */]
}, {
	path: '/view-visitor',
	component: __WEBPACK_IMPORTED_MODULE_5__pages_Visits_ViewVisitor__["a" /* default */],
	name: 'viewVisitor',
	beforeEnter: __WEBPACK_IMPORTED_MODULE_10__guards__["a" /* loginGuard */]
}, {
	path: '/mail',
	component: __WEBPACK_IMPORTED_MODULE_6__pages_Mail_Mail__["a" /* default */],
	name: 'mail',
	beforEnter: __WEBPACK_IMPORTED_MODULE_10__guards__["a" /* loginGuard */]
}, {
	path: '/broadcast-messages',
	component: __WEBPACK_IMPORTED_MODULE_12__pages_BroadcastMessages_BroadcastMessages__["a" /* default */],
	name: 'broadcastMessages',
	beforEnter: __WEBPACK_IMPORTED_MODULE_10__guards__["a" /* loginGuard */]
}, {
	path: '/shatter',
	component: __WEBPACK_IMPORTED_MODULE_7__pages_Shatter_Shatter__["a" /* default */],
	name: 'shatter'
}, {
	path: '/register',
	component: __WEBPACK_IMPORTED_MODULE_8__pages_Login_Register_Register__["a" /* default */],
	name: 'register'
}, {
	path: '/recover-password',
	component: __WEBPACK_IMPORTED_MODULE_9__pages_Login_RecoverPassword_RecoverPassword__["a" /* default */],
	name: 'RecoverPassword'
}, {
	path: '/my-account',
	component: __WEBPACK_IMPORTED_MODULE_11__pages_MyAccount_MyAccount_vue__["a" /* default */],
	name: 'MyAccount'
}, {
	path: '/request-assistance',
	component: __WEBPACK_IMPORTED_MODULE_13__pages_Assistance_RequestAssistance__["a" /* default */],
	name: 'requestAssistance'
}, {
	path: '/update-email-confirm',
	component: __WEBPACK_IMPORTED_MODULE_14__pages_MyAccount_ChangeEmail_UpdateEmailConfirm__["a" /* default */],
	name: 'udateEmailConfirm'
}];

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(57);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b244e3b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(310);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b244e3b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('img',{attrs:{"src":__webpack_require__(44),"width":"320","alt":""}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticStyle:{"text-transform":"lowercase"},attrs:{"label":"Usuario"},model:{value:(_vm.credentials.username),callback:function ($$v) {_vm.$set(_vm.credentials, "username", $$v)},expression:"credentials.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Contraseña","type":_vm.showPassword ? 'input' : 'password',"append-icon":_vm.showPassword ? 'visibility_off' : 'visibility'},on:{"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.credentials.password),callback:function ($$v) {_vm.$set(_vm.credentials, "password", $$v)},expression:"credentials.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.login($event)}}},[_vm._v("Ingresar")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-space-between":"true"}},[_c('v-btn',{attrs:{"small":"","outline":"","color":"primary"},on:{"click":function($event){_vm.$router.push({ name: 'register' })}}},[_vm._v("Registrarme")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","outline":"","color":"primary"},on:{"click":function($event){_vm.$router.push({ name: 'RecoverPassword' })}}},[_vm._v("Recuperar Contraseña")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":true,"timeout":3000,"text":"Error al autenticarse"},model:{value:(_vm.loginError),callback:function ($$v) {_vm.loginError=$$v},expression:"loginError"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.errorMessage)+"\n\t\t\t"),_c('v-btn',{attrs:{"color":"pink","flat":""},on:{"click":function($event){_vm.loginError = false}}},[_vm._v("\n\t\t\t\tCerrar\n\t\t\t")])],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showNotificationsWindow),callback:function ($$v) {_vm.showNotificationsWindow=$$v},expression:"showNotificationsWindow"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline orange white--text"},[_vm._v("\n\t\t\t\t\tActivación de notificaciones\n\t\t\t\t")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n\t\t\t\t\t¿Desea recibir una notificación cuando reciba a un\n\t\t\t\t\tvisitante o correpondencia nueva?\n\t\t\t\t")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"green"},on:{"click":_vm.acceptNotifications}},[_vm._v("SI")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},on:{"click":_vm.denyNotifications}},[_vm._v("NO")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.$router.push({ name: 'visits' })}}},[_vm._v("Visitas")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.$router.push({ name: 'mail' })}}},[_vm._v("Correspondencia")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.$router.push({ name: 'broadcastMessages' })}}},[_vm._v("Circulares")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.$router.push({ name: 'shatter' })}}},[_vm._v("Conoce a Shatter")]),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    user: function user(state) {
        return state.user;
    },
    authenticated: function authenticated(state) {
        return !!state.user;
    },
    person: function person(state) {
        if (!state.user) return null;

        return state.user.person;
    },
    hasSubscriptions: function hasSubscriptions(state) {
        return state.hasSubscriptions;
    },

    updatedEmail: function updatedEmail(state) {
        return state.updatedEmail;
    },
    version: function version(state) {
        return state.version;
    },
    updateRequired: function updateRequired(state) {
        return state.updateRequired;
    }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commitTypes__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actionTypes__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__repositories_subscriptions_repository__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notifications_vapidFuntions__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mutations__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repositories_auth_repository__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__repositories_app_repository__ = __webpack_require__(308);






var _actionTypes$LOGOUT$a;









/* harmony default export */ __webpack_exports__["a"] = (_actionTypes$LOGOUT$a = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["b" /* LOGOUT */], function (_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit(__WEBPACK_IMPORTED_MODULE_5__commitTypes__["f" /* SET_USER */], null);
        resolve();
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["f" /* SAVE_SUBSCRIPTION */], function (_ref2, subscription) {
    var _this = this;

    var state = _ref2.state,
        commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sr, payload, _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        sr = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__repositories_subscriptions_repository__["a" /* default */]);
                        payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ user: state.user.id }, subscription);
                        _context.next = 4;
                        return sr.saveSubscription(payload);

                    case 4:
                        _ref3 = _context.sent;
                        data = _ref3.data;
                        return _context.abrupt('return', data);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["i" /* VERIFY_SUBSCRIPTION */], function (_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    // navigator.serviceWorker.ready.then(swReg => {
    //     swReg.pushManager.getSubscription().then(subs => {
    //         commit(commitTypes.SET_NOTIFY_SUBS, sub);
    //     });
    // })
    if (state.user.notifications_enabled) {
        dispatch(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* UPDATE_SUBSCRIPTION */]);
    }
    // const sr = { ...subscriptionsRepository };
    // sr.getSubscriptions(state.user.id)
    //     .then(resp => {
    //         const hasSubs = !!resp.data.length;
    //         commit(commitTypes.SET_HAS_SUBS, hasSubs);
    //     })
    //     .catch(console.log);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* LOAD_INITIAL_STATE */], function (_ref5) {
    var commit = _ref5.commit;

    var jsonState = localStorage.getItem('bm_state');
    if (!jsonState) return;

    var initialState = JSON.parse(jsonState);
    commit(__WEBPACK_IMPORTED_MODULE_5__commitTypes__["d" /* SET_STATE */], initialState);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* UPDATE_SUBSCRIPTION */], function (_ref6) {
    var dispatch = _ref6.dispatch,
        commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
            toastr.warning('Las notificaciones no son soportadas por su dispositivo');
            dispatch(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["e" /* SAVE_NOTIFICATIONS_SUPPORT */], 'NO');
            return;
        }

        if (Notification.permission === 'denied') {
            dispatch(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* SAVE_NOTIFICATIONS_ALLOWED */], 'NO');
            toastr.warning('Notificaciones bloqueadas por el usuario');
            return;
        }

        if (!('PushManager' in window)) {
            dispatch(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["e" /* SAVE_NOTIFICATIONS_SUPPORT */], 'NO');
            toastr.warning('Las notificaciones push no son soportadas por su dispositivo');
            return;
        }

        navigator.serviceWorker.ready.then(function (swReg) {

            var options = { userVisibleOnly: true };
            var vapidPublicKey = __WEBPACK_IMPORTED_MODULE_8__notifications_vapidFuntions__["a" /* default */].getPublicKey();
            if (vapidPublicKey) {
                options.applicationServerKey = vapidPublicKey;
            }

            // Notification.requestPermission().then(resp => {
            //     if(resp === 'granted') {
            swReg.pushManager.subscribe(options).then(function (subscription) {
                var key = subscription.getKey('p256dh');
                var token = subscription.getKey('auth');
                var data = {
                    endpoint: subscription.endpoint,
                    key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                    token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
                };

                try {
                    dispatch(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["f" /* SAVE_SUBSCRIPTION */], data).then(function (data) {
                        if (data.status) {
                            commit(__WEBPACK_IMPORTED_MODULE_5__commitTypes__["a" /* SET_HAS_SUBS */], data.status);
                            toastr.success('Subscripción actualizada satisfactoriamente');
                            resolve(data);
                        } else {
                            reject();
                            toastr.error(data.msg);
                        }
                    });
                } catch (err) {
                    toastr.error('Ocurri\xF3 un error al actualizar la subscripci\xF3n [' + err.message + ']');
                    reject();
                }
            }).catch(function (error) {
                if (Notification.permission === 'denied') {
                    return toastr.warning('Notificaciones bloqueadas por el usuario');
                } else {
                    return toastr.error('Ocurrió un error al guardar la subscripción');
                }
                reject();
            });
            // } else {
            //     toastr.error('Subscripciones bloqueadas por el navegador');
            // }
            // });
        });
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* SAVE_BROWSER_SPECTS */], function (_ref7, spects) {
    var _this2 = this;

    var state = _ref7.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var ar, _ref8, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        ar = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__repositories_auth_repository__["a" /* default */]);
                        _context2.next = 3;
                        return ar.saveBrowserSpects(state.user.id, spects);

                    case 3:
                        _ref8 = _context2.sent;
                        data = _ref8.data;
                        return _context2.abrupt('return', data);

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this2);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["e" /* SAVE_NOTIFICATIONS_SUPPORT */], function (_ref9, support) {
    var _this3 = this;

    var state = _ref9.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var ar, _ref10, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        ar = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__repositories_auth_repository__["a" /* default */]);
                        _context3.next = 3;
                        return ar.saveNotificationsSupport(state.user.id, { support: support });

                    case 3:
                        _ref10 = _context3.sent;
                        data = _ref10.data;
                        return _context3.abrupt('return', data);

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this3);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* SAVE_NOTIFICATIONS_ALLOWED */], function (_ref11, allowed) {
    var _this4 = this;

    var state = _ref11.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var ar, _ref12, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        ar = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__repositories_auth_repository__["a" /* default */]);
                        _context4.next = 3;
                        return ar.saveNotificationsAllowed(state.user.id, { allowed: allowed });

                    case 3:
                        _ref12 = _context4.sent;
                        data = _ref12.data;
                        return _context4.abrupt('return', data);

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this4);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actionTypes$LOGOUT$a, __WEBPACK_IMPORTED_MODULE_6__actionTypes__["h" /* VALIDATE_VERSION */], function (_ref13) {
    var _this5 = this;

    var state = _ref13.state,
        commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var ar, _ref14, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        ar = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__repositories_app_repository__["a" /* default */]);
                        _context5.prev = 1;
                        _context5.next = 4;
                        return ar.getLastVersion();

                    case 4:
                        _ref14 = _context5.sent;
                        data = _ref14.data;
                        return _context5.abrupt('return', data.version);

                    case 9:
                        _context5.prev = 9;
                        _context5.t0 = _context5['catch'](1);
                        return _context5.abrupt('return', null);

                    case 12:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this5, [[1, 9]]);
    }))();
}), _actionTypes$LOGOUT$a);

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_repository__ = __webpack_require__(30);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__base_repository__["a" /* default */], {
    saveSubscription: function saveSubscription(payload) {
        return this.post('subscriptions', payload);
    },
    getSubscriptions: function getSubscriptions(userId) {
        return this.get('subscriptions?user=' + userId);
    }
}));

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vapid_json__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vapid_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vapid_json__);

/* harmony default export */ __webpack_exports__["a"] = ({
    getPublicKey: function getPublicKey() {
        return urlBase64ToUint8Array(__WEBPACK_IMPORTED_MODULE_0__vapid_json___default.a.publicKey);
    }
});
function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = {"publicKey":"BAjYLZ6yJvPfuQq0-dFyauSbzW6pcdpkwbusahPhbOv0Rdy1L8nZjW3906G1jBd6UxP1Leh_ASzMxPjjs4vnR6A","privateKey":"D7yb0_v2bxQCh-oRQw6e-MVtwGQNWMm2GzgHITj3vEk"}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base2_repository__ = __webpack_require__(31);

/* harmony default export */ __webpack_exports__["a"] = ({
    getLastVersion: function getLastVersion() {
        return __WEBPACK_IMPORTED_MODULE_0__base2_repository__["a" /* default */].get('configuration/app-version');
    }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"content",attrs:{"column":""}},[(_vm.anUpdateRequired)?_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"update-required-box"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.updateApp($event)}}},[_vm._v("Actualizar la aplicación")])])])],1):_vm._e(),_vm._v(" "),_c('v-layout',[_c('img',{attrs:{"src":__webpack_require__(44),"width":"100%","alt":""}})]),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('app-menu')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',[_c(_vm.theComponent,{tag:"component"})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5534890_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__ = __webpack_require__(313);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5534890_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_repository__ = __webpack_require__(30);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__base_repository__["a" /* default */], {
	getPersonVisits: function getPersonVisits(personId, filters) {
		var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

		var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filters, {
			page: page,
			person: personId
		});
		return this.get('person-entries' + this.querify(params));
	},
	getVisitorTypes: function getVisitorTypes() {
		return this.get('vigilance/visitor-types');
	}
}));

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-content',[_c('app-title',[_vm._v("Visitas")]),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Filtros")]),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Filtros")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.visitorsTypes,"item-text":"name","item-value":"id","label":"Tipo visitante"},model:{value:(_vm.filters.visitorTypeId),callback:function ($$v) {_vm.$set(_vm.filters, "visitorTypeId", $$v)},expression:"filters.visitorTypeId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nombre visitante"},model:{value:(_vm.filters.name),callback:function ($$v) {_vm.$set(_vm.filters, "name", $$v)},expression:"filters.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha ingreso","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.filters.date),callback:function ($$v) {_vm.$set(_vm.filters, "date", $$v)},expression:"filters.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu = false}},model:{value:(_vm.filters.date),callback:function ($$v) {_vm.$set(_vm.filters, "date", $$v)},expression:"filters.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"small":"","color":"primary"},on:{"click":_vm.searchVisits}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"small":"","flat":""},on:{"click":_vm.cancelFilter}},[_vm._v("Restablecer")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.visits.length)?_c('div',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.visits),function(visit,index){return [_c('v-list-tile',{key:visit.name},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":visit.person.photo,"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(visit.person.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("datetime")(visit.created_at)))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(visit.visitor_type.name))])],1)],1),_vm._v(" "),_c('v-divider',{key:index})]})],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(!!_vm.visits.length)?_c('v-pagination',{attrs:{"length":_vm.totalPages},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()],1)],1):_c('v-alert',{attrs:{"value":!_vm.visits.length,"type":"info"}},[_vm._v("\n        ¡Aún no has recibido ninguna visita!\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewVisitor_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918d8f44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewVisitor_vue__ = __webpack_require__(315);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewVisitor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918d8f44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewVisitor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-content',[_c('app-title',[_vm._v("Nuevo Visitante")]),_vm._v(" "),_c('v-card',[_c('v-img',{attrs:{"src":_vm.$route.query.p}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$route.query.n))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"red"},on:{"click":function($event){_vm.sendResponse(0)}}},[_vm._v("Denegar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"green"},on:{"click":function($event){_vm.sendResponse(1)}}},[_vm._v("Aprobar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mail_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7035586_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mail_vue__ = __webpack_require__(319);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7035586_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_repository__ = __webpack_require__(30);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__base_repository__["a" /* default */], {
    getMails: function getMails(personId, filters) {
        var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

        var qs = this.querify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filters, { person: personId, page: page }));
        return this.get('mails' + qs);
    },
    getMailTypes: function getMailTypes() {
        return this.get('vigilance/mail-types');
    }
}));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-content',[_c('app-title',[_vm._v("Correspondencia")]),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Filtros")]),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Filtros")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.mailTypes,"item-text":"name","item-value":"id","label":"Tipo de correspondencia"},model:{value:(_vm.filters.type),callback:function ($$v) {_vm.$set(_vm.filters, "type", $$v)},expression:"filters.type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha recibimiento","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.filters.date),callback:function ($$v) {_vm.$set(_vm.filters, "date", $$v)},expression:"filters.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu = false}},model:{value:(_vm.filters.date),callback:function ($$v) {_vm.$set(_vm.filters, "date", $$v)},expression:"filters.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"small":"","color":"primary"},on:{"click":_vm.searchMails}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"small":"","flat":""},on:{"click":_vm.cancelFilter}},[_vm._v("Restablecer")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.mails)?_c('div',[_c('v-list',{attrs:{"two-lines":""}},[_vm._l((_vm.mails),function(mail,index){return [_c('v-list-tile',{key:mail.name,staticClass:"mail-item"},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":__webpack_require__(320),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Recibido el:")]),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("datetime")(mail.created_at)))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Estado:")]),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(!!mail.delivered
									? 'Entregado'
									: 'Sin Entregar'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Notas:")]),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(!!mail.notes
									? mail.notes
									: '-- Sin notas --'))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.seeMore(mail)}},slot:"activator"},[_c('v-icon',[_vm._v("zoom_in")])],1)],1)],1),_vm._v(" "),_c('v-divider',{key:index})]})],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(!!_vm.mails)?_c('v-pagination',{attrs:{"length":_vm.totalPages},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()],1)],1):_c('v-alert',{attrs:{"value":!_vm.mails,"type":"info"}},[_vm._v("\n\t\t¡Aún no has recibido correspondencia!\n\t")]),_vm._v(" "),(_vm.selectMail)?_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.closeDialogSeeMore}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Información detallada")])],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Información")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Estado:")]),_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(!!_vm.selectMail.delivered
										? 'Entregado'
										: 'Sin Entregar'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Tipo: ")]),_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.selectMail.mail_type.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Recibido el:")]),_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("datetime")(_vm.selectMail.created_at)))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Notas:")]),_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(!!_vm.selectMail.notes
										? _vm.selectMail.notes
										: '-- Sin notas --'))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.selectMail.photos.length)?_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Fotos")]),_vm._v(" "),_vm._l((_vm.selectMail.photos),function(item,i){return _c('v-row',{key:i},[_c('v-flex',{staticClass:"mb-2"},[_c('v-card',{staticClass:"pa-2"},[_c('v-img',{staticClass:"photo",attrs:{"src":item.photo_url}})],1)],1)],1)})],2):_vm._e()],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shatter_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de310ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shatter_vue__ = __webpack_require__(323);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shatter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de310ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shatter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = {"name":"Shatter Seguridad","addresses":[{"address":"Cra 24 # 5-51 Barrio/ Alameda","city":"Cali","country":"Colombia"},{"address":"Calle 75 # 23 - 54 Barrio/ Alcázares Norte","city":"Bogota","country":"Colombia"}],"phones":[{"label":"Cali","value":"514 77 00"},{"label":"Bogota","value":"(051) 346 42 26"}],"emails":[{"label":"Servicio al Cliente","value":"solucionesoportunas@seguridadshatter.com"}],"website":"https://seguridadshatter.com"}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[_c('img',{attrs:{"src":__webpack_require__(324),"width":"100%","alt":""}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('app-title',[_vm._v("Ubicación")]),_vm._v(" "),_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3982.6399825044564!2d-76.54035428489344!3d3.4374639522702815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e30a68592fe1df7%3A0x982ce11a688e2671!2sShatter+Seguridad!5e0!3m2!1sen!2sco!4v1542660832689","width":"350","height":"350","frameborder":"0","allowfullscreen":""}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-list',{attrs:{"subheader":"","three-line":""}},[_c('v-subheader',[_vm._v("Información General")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Direcciones")]),_vm._v(" "),_vm._l((_vm.shatterInfo.addresses),function(address,i){return _c('v-list-tile-sub-title',{key:i},[_vm._v(" "+_vm._s(address.city)+", "+_vm._s(address.country)+": "+_vm._s(address.address))])})],2)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Sitio Web")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('a',{attrs:{"href":_vm.shatterInfo.website}},[_vm._v(_vm._s(_vm.shatterInfo.website))])])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Teléfonos")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.shatterInfo.phones),function(phone){return _c('v-flex',{key:phone.value,attrs:{"xs12":""}},[_vm._v(_vm._s(phone.label)+": "+_vm._s(phone.value))])}))],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("E-mails")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.shatterInfo.emails),function(email){return _c('v-flex',{key:email.value,attrs:{"xs12":""}},[_vm._v(_vm._s(email.label)+": "),_c('a',{attrs:{"href":'mailto:' + email.value}},[_vm._v(_vm._s(email.value))])])}))],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shatter_logo.54896fa.png";

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b0c4452_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b0c4452_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-container',[_c('v-layout',{attrs:{"justify-center":""}},[_c('h2',[_vm._v("Registro de Usuario")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","placeholder":"Código Administración","error-messages":_vm.errors.clientCode},on:{"change":_vm.loadStructures,"input":function($event){_vm.$v.register.clientCode.$touch()}},model:{value:(_vm.register.clientCode),callback:function ($$v) {_vm.$set(_vm.register, "clientCode", $$v)},expression:"register.clientCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","placeholder":"Nombre Completo","error-messages":_vm.errors.name},on:{"input":function($event){_vm.$v.register.name.$touch()}},model:{value:(_vm.register.name),callback:function ($$v) {_vm.$set(_vm.register, "name", $$v)},expression:"register.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","placeholder":"Documento de identidad","error-messages":_vm.errors.document},on:{"input":function($event){_vm.$v.register.document.$touch()}},model:{value:(_vm.register.document),callback:function ($$v) {_vm.$set(_vm.register, "document", $$v)},expression:"register.document"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","placeholder":"E-mail","error-messages":_vm.errors.email},on:{"input":function($event){_vm.$v.register.email.$touch()}},model:{value:(_vm.register.email),callback:function ($$v) {_vm.$set(_vm.register, "email", $$v)},expression:"register.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","placeholder":"Torre - Apto / Casa / Oficina / Área","error-messages":_vm.errors.structure},on:{"input":function($event){_vm.$v.register.structure.$touch()}},model:{value:(_vm.register.structure),callback:function ($$v) {_vm.$set(_vm.register, "structure", $$v)},expression:"register.structure"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.birthDateMenu),callback:function ($$v) {_vm.birthDateMenu=$$v},expression:"birthDateMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","required":"","value":_vm.formatedDate,"label":"Fecha de nacimiento","prepend-icon":"event","readonly":"","error-messages":_vm.errors.birthDate},slot:"activator"}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.birthDateMenu = false}},model:{value:(_vm.register.birthDate),callback:function ($$v) {_vm.$set(_vm.register, "birthDate", $$v)},expression:"register.birthDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Acepto las politicas de tratamiento de datos","value":"1"},model:{value:(_vm.register.optIn),callback:function ($$v) {_vm.$set(_vm.register, "optIn", $$v)},expression:"register.optIn"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('small',[_c('a',{attrs:{"href":"http://www.seguridadshatter.com/politica-datos-shatter.pdf","target":"_blank"}},[_vm._v("Ver politicas")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.register.optIn.length || _vm.inProgress},on:{"click":_vm.registerUser}},[_vm._v("Registrarme")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59802a58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__ = __webpack_require__(351);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59802a58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('img',{attrs:{"src":__webpack_require__(44),"width":"320","alt":""}})])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","placeholder":"E-mail","error-messages":_vm.errors.email},on:{"input":function($event){_vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.resetPassword}},[_vm._v("Restablecer contraseña")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1ba27d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__ = __webpack_require__(357);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1ba27d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7f371f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(354);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7f371f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-content',[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Cambiar contraseña")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","label":"Escriba la contraseña actual","type":_vm.showOldPassword? 'input':'password',"append-icon":_vm.showOldPassword ? 'visibility_off' : 'visibility',"error-messages":_vm.errors.oldPassword},on:{"click:append":function($event){_vm.showOldPassword = !_vm.showOldPassword},"input":function($event){_vm.$v.passwords.oldPassword.$touch()}},model:{value:(_vm.passwords.oldPassword),callback:function ($$v) {_vm.$set(_vm.passwords, "oldPassword", $$v)},expression:"passwords.oldPassword"}})],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","label":"Escriba la nueva contraseña","type":_vm.showNewPassword1? 'input':'password',"append-icon":_vm.showNewPassword1 ? 'visibility_off' : 'visibility',"error-messages":_vm.errors.newPassword1},on:{"click:append":function($event){_vm.showNewPassword1 = !_vm.showNewPassword1},"input":function($event){_vm.$v.passwords.newPassword1.$touch()}},model:{value:(_vm.passwords.newPassword1),callback:function ($$v) {_vm.$set(_vm.passwords, "newPassword1", $$v)},expression:"passwords.newPassword1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","label":"Confirme la nueva contraseña","type":_vm.showNewPassword2? 'input':'password',"append-icon":_vm.showNewPassword2 ? 'visibility_off' : 'visibility',"error-messages":_vm.errors.newPassword2},on:{"click:append":function($event){_vm.showNewPassword2 = !_vm.showNewPassword2},"input":function($event){_vm.$v.passwords.newPassword2.$touch()}},model:{value:(_vm.passwords.newPassword2),callback:function ($$v) {_vm.$set(_vm.passwords, "newPassword2", $$v)},expression:"passwords.newPassword2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"primary","block":"","disable":_vm.inProgress},on:{"click":_vm.changePassword}},[_vm._v("Cambiar contraseña")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":true,"timeout":4000},model:{value:(_vm.changePasswordMsg),callback:function ($$v) {_vm.changePasswordMsg=$$v},expression:"changePasswordMsg"}},[_vm._v("\n            "+_vm._s(_vm.msg)+"\n            "),_c('v-btn',{attrs:{"color":"pink","flat":""},on:{"click":function($event){_vm.changePasswordMsg = false}}},[_vm._v("\n                Cerrar\n            ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeEmail_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32baabe5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeEmail_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32baabe5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-4"},[_c('v-card-title',[_c('app-title',[_vm._v("Actualización de Correo")])],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('label',{attrs:{"for":""}},[_vm._v("Correo Actual:")]),_vm._v("\n                "+_vm._s(!!_vm.user && !!_vm.user.email? _vm.user.email: 'Sin Correo')+"\n            ")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-text-field',{attrs:{"color":"primary","type":"email","error-messages":_vm.emailErrors},on:{"input":function($event){_vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.inProgress,"block":"","type":"email","name":"email","id":"email"},on:{"click":_vm.confirm}},[_vm._v("Actualizar Correo")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-content',[_c('app-title',[_vm._v("Mi cuenta")]),_vm._v(" "),_c('v-tabs',{attrs:{"color":"primary","dark":"","slider-color":"yellow"}},[_c('v-tab',[_vm._v("\n            Correo\n        ")]),_vm._v(" "),_c('v-tab',[_vm._v("\n            Contraseña\n        ")]),_vm._v(" "),_c('v-tab-item',[_c('app-change-email',{on:{"confirm":_vm.onChangeEmail}})],1),_vm._v(" "),_c('v-tab-item',[_c('app-change-password')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BroadcastMessages_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1d095c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BroadcastMessages_vue__ = __webpack_require__(361);
function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BroadcastMessages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1d095c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BroadcastMessages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base2_repository__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = ({
    getBroadcastMessages: function getBroadcastMessages(userId, filters) {
        var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        return __WEBPACK_IMPORTED_MODULE_1__base2_repository__["a" /* default */].get('broadcast-messages/' + userId + '/by-user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filters, { page: page }));
    }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-content',[_c('app-title',[_vm._v("Circulares")]),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                Filtros\n            ")]),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Filtros")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha Circular","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.filters.date),callback:function ($$v) {_vm.$set(_vm.filters, "date", $$v)},expression:"filters.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu = false}},model:{value:(_vm.filters.date),callback:function ($$v) {_vm.$set(_vm.filters, "date", $$v)},expression:"filters.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"small":"","color":"primary"},on:{"click":_vm.searchBroadcastMessages}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"small":"","flat":""},on:{"click":_vm.cancelFilter}},[_vm._v("Restablecer")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(!!_vm.messages.length)?_c('div',[_c('v-list',{attrs:{"two-lines":""}},[_vm._l((_vm.messages),function(message,index){return [_c('v-list-tile',{key:message.id,staticClass:"message-item"},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":__webpack_require__(362),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Asunto: ")]),_vm._v(" "+_vm._s(message.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Fecha: ")]),_vm._v(" "+_vm._s(_vm._f("datetime")(message.created_at)))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.drillDown(message)}},slot:"activator"},[_c('v-icon',[_vm._v("zoom_in")])],1)],1)],1),_vm._v(" "),_c('v-divider',{key:index})]})],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(!!_vm.messages)?_c('v-pagination',{attrs:{"length":_vm.totalPages},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()],1)],1):_c('v-alert',{attrs:{"value":!_vm.mails,"type":"info"}},[_vm._v("\n        !Aún no has recibido ninguna circular!\n    ")]),_vm._v(" "),(_vm.selectedMessage)?_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.drillUp}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Información Circular")])],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Información")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Asunto:")]),_vm._v(" "+_vm._s(_vm.selectedMessage.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('strong',[_vm._v("Recibida el:")]),_vm._v(" "+_vm._s(_vm._f("datetime")(_vm.selectedMessage.created_at)))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"message-container"},[_c('div',{staticClass:"message-content",domProps:{"innerHTML":_vm._s(_vm.selectedMessage.description)}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.selectedMessage.client_broadcast_message_files.length)?_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Archivos")]),_vm._v(" "),_vm._l((_vm.selectedMessage.client_broadcast_message_files),function(file){return _c('v-list-tile',{key:file.id},[_c('v-list-tile-content',[_c('v-btn',{attrs:{"href":file.file_url,"target":"_blank"}},[_vm._v(_vm._s(file.name))])],1)],1)})],2):_vm._e()],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAG7AAABuwE67OPiAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAActQTFRF/////4CA6EZG7kRE9ENO9UdH80lJ8EZL8khM80lM8kdK8klM80dM8UdL8UhM8khM80dL8UhM8khLmNnVwOjmisrWtd/k8khL8khMbajXmNnVwOjmwublwuTjicnV8khLmNnVwOnmtd/kzcC/80lL8khLisnVjsnW3oqL3YiJ8khLsNvj8khLi8rV8khLmdjVmtrW8UhLjMvWl9jWnNrXrtninNrW8khL8khLGF+NGWCNGmGOI2iTJ2uVKm6WLG+XMHKaMnSbN3idQH+iQoGjR4WmUIyqUo6rXJaxZZ21Z5+3bKO5bajWdKq+daq+dqu/d6y/ea7Af7LDgLPEgbTEhLfGhbfGh7nIiMbVirvJjMTZjMvVj7/LkcHNlMPOmNnVmcfRmdTZmsjRnMrSndfZndrXndvXoM3Voc7Vodrapd3bp9PYp9/bqNTZqtXaquDdrNfbrNjirdjcsNvds93ftN7ftt/gueLivOTkvublwOfmweflwejmwuXkw+Dfw+HfxN7cxdrZx9bUyc7MysrJzcLB0bOy1aam1aen16Ki2J2d2J6e25WV3I6P3oiJ4ISF6Gps6mRm7Fxe7Vhb7lZZ8E1Q8UxP8khL8klMWaqXYwAAADl0Uk5TAAILDxcZKjM5V2RlaIGDh5OUo6+vs7bFx9DQ0NDR1NfY2ODg4ePk6Onq6u3x9PT19fX29vf5+/3+ArwZsAAAAY9JREFUWMPt11VTAlEYh3Fs7E5sxO7ubtduBVExsDEwV8XuVl4/ruwKXOxwzu4exnEcfG7g5v+bgXd2GCQSc86+EZlxQVIJaR4KYCrxJ9y7KiDJz10aWAo+ZEAApLswr16Q7Uayd8oD7+934eBJsA+JkcujZWypkCbDFhbJFBplKtgKJNDWbuGJxpZIMSWrTcUTARkskG8LuL4TAhSxwLgtwPh5LABYRwMAhr8OGOGUpu/hkRh4hofDk1e4IgYuAd6N8GYgBuibD4CXc5ocoI8uzg5oewAh/SywqkWnEwD0l+Ea5Qcma6vQ1c3/iS/x14GJ6kp0NRp+YKgcc8UKpYCPsKVDp3eMK6w0N6Fr2eAHurEP0wA/sKscRqfac4grbHd1oOvZ4Qc6sVfo4wc221rRtesd4gr70yp0GgFAL/YKg/yAtqEeXePS/w+LfcDaMtviwszUGBEwp7Y0QtkHmPfEgGVPClj3ooFZzl40UMzZiwYKOXvRQC5nLxrI4eypLJFAAWeP+d9ouxTOnoq1Al9vYkSELKO8AwAAAABJRU5ErkJggg=="

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestAssistance_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ff03ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestAssistance_vue__ = __webpack_require__(366);
function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02ff03ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestAssistance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ff03ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestAssistance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base2_repository__ = __webpack_require__(31);

/* harmony default export */ __webpack_exports__["a"] = ({
    requestAssistance: function requestAssistance(userId) {
        return __WEBPACK_IMPORTED_MODULE_0__base2_repository__["a" /* default */].post('vigilance/request-assistance', { userId: userId });
    }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-content',[_c('app-title',[_vm._v("Solicitar Asistencia")]),_vm._v(" "),_c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticClass:"title",attrs:{"type":"info","outline":"","value":true}},[_vm._v("\n                    Recuerde que esta opción es para casos de emergencia y debe estar en las instalaciones vigiladas por Seguridad Shatter\n                ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-btn',{staticClass:"mega-button white--text",attrs:{"color":"green","large":"","block":""},on:{"click":_vm.requestAssistance}},[_vm._v("Solicitar Asistencia")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-btn',{staticClass:"mega-button",attrs:{"color":"secondary","large":"","block":""},on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateEmailConfirm_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfc3df9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateEmailConfirm_vue__ = __webpack_require__(368);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateEmailConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfc3df9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateEmailConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',[_c('v-card',[_c('v-card-title',[_c('app-title',[_vm._v("Finalización de actualización de información")])],1),_vm._v(" "),_c('v-card-text',[_c('h5',[_vm._v("Su solicitud ha sido recibida")]),_vm._v(" "),_c('p',[_vm._v("Por favor confirmela ingresando el código de 4 dígitos que fue enviado a su nuevo correo")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Código","error-messages":_vm.codeErrors},on:{"input":function($event){_vm.$v.code.$touch()}},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',[_c('v-flex',[_c('v-btn',{staticClass:"mb-5",attrs:{"block":"","color":"primary"},on:{"click":_vm.validateCode}},[_vm._v("Confirmar Código")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-btn',{attrs:{"block":"","color":"secondary"},on:{"click":function($event){_vm.$router.push({ name: 'home' })}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */,
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return theme; });
var theme = {
    primary: "#FF761C",
    secondary: "#232655",
    accent: "#9c27b0",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return datetime; });
var datetime = function datetime(val) {
    if (!val) return '';

    var date = window.moment(val);

    return date.isValid() ? date.format('DD/MM/YYYY HH:mm:ss') : '';
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8bb2f9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageContent_vue__ = __webpack_require__(375);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8bb2f9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a2bd8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17a2bd8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a2bd8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-title"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);


var mixin = {
    data: function data() {
        return {
            processing: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'person']), {
        inProgress: function inProgress() {
            return this.processing;
        }
    }),
    methods: {
        startProcessing: function startProcessing() {
            this.processing = true;
        },
        stopProcessing: function stopProcessing() {
            this.processing = false;
        }
    }
};

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, exports) {

(function () {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
            navigator.serviceWorker.register('/sw.js', {
                updateViaCache: 'none'
            }).then(function (registration) {
                console.log('SW: Registration ok, waiting for subscription validation');

                registration.onupdatefound = function () {
                    var installingWorker = registration.installing;
                    installingWorker.onstatechange = function () {
                        switch (installingWorker.state) {
                            case 'installed':
                                if (navigator.serviceWorker.controller) {
                                    location.reload(true);
                                } else {
                                    console.log('nothing to update');
                                }
                                break;
                        }
                    };
                };

                navigator.serviceWorker.ready.then(function (swReg) {
                    swReg.pushManager.getSubscription().then(function (sub) {
                        console.log('Subscripción', sub);
                    });
                }).catch(console.log);
            }).catch(function (registrationError) {
                console.log('SW registration failed: ', registrationError);
            });
        });
    }
})();

/***/ }),
/* 384 */,
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 95,
	"./af.js": 95,
	"./ar": 96,
	"./ar-dz": 97,
	"./ar-dz.js": 97,
	"./ar-kw": 98,
	"./ar-kw.js": 98,
	"./ar-ly": 99,
	"./ar-ly.js": 99,
	"./ar-ma": 100,
	"./ar-ma.js": 100,
	"./ar-sa": 101,
	"./ar-sa.js": 101,
	"./ar-tn": 102,
	"./ar-tn.js": 102,
	"./ar.js": 96,
	"./az": 103,
	"./az.js": 103,
	"./be": 104,
	"./be.js": 104,
	"./bg": 105,
	"./bg.js": 105,
	"./bm": 106,
	"./bm.js": 106,
	"./bn": 107,
	"./bn.js": 107,
	"./bo": 108,
	"./bo.js": 108,
	"./br": 109,
	"./br.js": 109,
	"./bs": 110,
	"./bs.js": 110,
	"./ca": 111,
	"./ca.js": 111,
	"./cs": 112,
	"./cs.js": 112,
	"./cv": 113,
	"./cv.js": 113,
	"./cy": 114,
	"./cy.js": 114,
	"./da": 115,
	"./da.js": 115,
	"./de": 116,
	"./de-at": 117,
	"./de-at.js": 117,
	"./de-ch": 118,
	"./de-ch.js": 118,
	"./de.js": 116,
	"./dv": 119,
	"./dv.js": 119,
	"./el": 120,
	"./el.js": 120,
	"./en-au": 121,
	"./en-au.js": 121,
	"./en-ca": 122,
	"./en-ca.js": 122,
	"./en-gb": 123,
	"./en-gb.js": 123,
	"./en-ie": 124,
	"./en-ie.js": 124,
	"./en-il": 125,
	"./en-il.js": 125,
	"./en-nz": 126,
	"./en-nz.js": 126,
	"./eo": 127,
	"./eo.js": 127,
	"./es": 128,
	"./es-do": 129,
	"./es-do.js": 129,
	"./es-us": 130,
	"./es-us.js": 130,
	"./es.js": 128,
	"./et": 131,
	"./et.js": 131,
	"./eu": 132,
	"./eu.js": 132,
	"./fa": 133,
	"./fa.js": 133,
	"./fi": 134,
	"./fi.js": 134,
	"./fo": 135,
	"./fo.js": 135,
	"./fr": 136,
	"./fr-ca": 137,
	"./fr-ca.js": 137,
	"./fr-ch": 138,
	"./fr-ch.js": 138,
	"./fr.js": 136,
	"./fy": 139,
	"./fy.js": 139,
	"./gd": 140,
	"./gd.js": 140,
	"./gl": 141,
	"./gl.js": 141,
	"./gom-latn": 142,
	"./gom-latn.js": 142,
	"./gu": 143,
	"./gu.js": 143,
	"./he": 144,
	"./he.js": 144,
	"./hi": 145,
	"./hi.js": 145,
	"./hr": 146,
	"./hr.js": 146,
	"./hu": 147,
	"./hu.js": 147,
	"./hy-am": 148,
	"./hy-am.js": 148,
	"./id": 149,
	"./id.js": 149,
	"./is": 150,
	"./is.js": 150,
	"./it": 151,
	"./it.js": 151,
	"./ja": 152,
	"./ja.js": 152,
	"./jv": 153,
	"./jv.js": 153,
	"./ka": 154,
	"./ka.js": 154,
	"./kk": 155,
	"./kk.js": 155,
	"./km": 156,
	"./km.js": 156,
	"./kn": 157,
	"./kn.js": 157,
	"./ko": 158,
	"./ko.js": 158,
	"./ky": 159,
	"./ky.js": 159,
	"./lb": 160,
	"./lb.js": 160,
	"./lo": 161,
	"./lo.js": 161,
	"./lt": 162,
	"./lt.js": 162,
	"./lv": 163,
	"./lv.js": 163,
	"./me": 164,
	"./me.js": 164,
	"./mi": 165,
	"./mi.js": 165,
	"./mk": 166,
	"./mk.js": 166,
	"./ml": 167,
	"./ml.js": 167,
	"./mn": 168,
	"./mn.js": 168,
	"./mr": 169,
	"./mr.js": 169,
	"./ms": 170,
	"./ms-my": 171,
	"./ms-my.js": 171,
	"./ms.js": 170,
	"./mt": 172,
	"./mt.js": 172,
	"./my": 173,
	"./my.js": 173,
	"./nb": 174,
	"./nb.js": 174,
	"./ne": 175,
	"./ne.js": 175,
	"./nl": 176,
	"./nl-be": 177,
	"./nl-be.js": 177,
	"./nl.js": 176,
	"./nn": 178,
	"./nn.js": 178,
	"./pa-in": 179,
	"./pa-in.js": 179,
	"./pl": 180,
	"./pl.js": 180,
	"./pt": 181,
	"./pt-br": 182,
	"./pt-br.js": 182,
	"./pt.js": 181,
	"./ro": 183,
	"./ro.js": 183,
	"./ru": 184,
	"./ru.js": 184,
	"./sd": 185,
	"./sd.js": 185,
	"./se": 186,
	"./se.js": 186,
	"./si": 187,
	"./si.js": 187,
	"./sk": 188,
	"./sk.js": 188,
	"./sl": 189,
	"./sl.js": 189,
	"./sq": 190,
	"./sq.js": 190,
	"./sr": 191,
	"./sr-cyrl": 192,
	"./sr-cyrl.js": 192,
	"./sr.js": 191,
	"./ss": 193,
	"./ss.js": 193,
	"./sv": 194,
	"./sv.js": 194,
	"./sw": 195,
	"./sw.js": 195,
	"./ta": 196,
	"./ta.js": 196,
	"./te": 197,
	"./te.js": 197,
	"./tet": 198,
	"./tet.js": 198,
	"./tg": 199,
	"./tg.js": 199,
	"./th": 200,
	"./th.js": 200,
	"./tl-ph": 201,
	"./tl-ph.js": 201,
	"./tlh": 202,
	"./tlh.js": 202,
	"./tr": 203,
	"./tr.js": 203,
	"./tzl": 204,
	"./tzl.js": 204,
	"./tzm": 205,
	"./tzm-latn": 206,
	"./tzm-latn.js": 206,
	"./tzm.js": 205,
	"./ug-cn": 207,
	"./ug-cn.js": 207,
	"./uk": 208,
	"./uk.js": 208,
	"./ur": 209,
	"./ur.js": 209,
	"./uz": 210,
	"./uz-latn": 211,
	"./uz-latn.js": 211,
	"./uz.js": 210,
	"./vi": 212,
	"./vi.js": 212,
	"./x-pseudo": 213,
	"./x-pseudo.js": 213,
	"./yo": 214,
	"./yo.js": 214,
	"./zh-cn": 215,
	"./zh-cn.js": 215,
	"./zh-hk": 216,
	"./zh-hk.js": 216,
	"./zh-tw": 217,
	"./zh-tw.js": 217
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385;

/***/ })
],[218]);


// WEBPACK FOOTER //
// static/js/app.52331151b6230f00076b.js